export const inputCls =
  "w-full rounded-xl border border-aspira-goldborder bg-white px-4 py-3 text-sm text-aspira-ink placeholder-aspira-muted outline-none transition-colors duration-200 focus:border-aspira-gold focus:ring-2 focus:ring-aspira-gold/25";

export const Label = ({ children, htmlFor }) => (
  <label
    htmlFor={htmlFor}
    className="mb-1.5 block text-[11px] font-semibold uppercase tracking-[0.18em] text-aspira-muted"
  >
    {children}
  </label>
);

export const GoldButton = ({ children, className = "", ...props }) => (
  <button
    className={`group inline-flex items-center justify-center gap-2 rounded-full bg-aspira-gold px-7 py-3.5 text-sm font-semibold text-white shadow-md transition-all duration-300 hover:bg-aspira-goldhover hover:shadow-xl disabled:cursor-not-allowed disabled:opacity-60 ${className}`}
    {...props}
  >
    {children}
  </button>
);
